import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Cross from '@strapi/icons/Cross';
import Search from '@strapi/icons/Search';
import { FieldAction, FieldInput } from '@strapi/design-system/Field';
import { CloseIconWrapper, Dropdown, DropdownItem, SearchBarWrapper, SearchIconWrapper } from './styledComponents/SearchBar.styled';
import { useFetchGlossaryTerms } from '../../api';
import { Button } from '@strapi/design-system';
import { GlossaryConst } from '../../utils';
import styles from './styledComponents/SearchInput.module.css';
import { useSelector } from 'react-redux';
const createNewOne = [{
  term: GlossaryConst.CREATE_NEW_GLOSSARY_TERM,
  id: 0
}];
const noResultsFound = [{
  term: GlossaryConst.NO_RESULTS_FOUND,
  id: -1
}];
const SearchInput = /*#__PURE__*/React.memo(({
  searchValue,
  setSearchValue,
  suggestionClickCallback,
  isTextSelected
}) => {
  const activityDraft = useSelector(state => state.activityDraft);
  const {
    records,
    fetchData
  } = useFetchGlossaryTerms();
  const searchCallback = value => {
    setSearchValue(value);
    if (value.trim() === '') {
      return;
    }
    fetchData(value, activityDraft);
  };
  const fullMatch = useMemo(() => {
    for (let item of records) {
      if (item.term === searchValue) {
        return true;
      }
    }
    return false;
  }, [records, searchValue]);
  const options = useMemo(() => {
    const filteredSuggestions = records;
    if (!filteredSuggestions.length && searchValue && isTextSelected) {
      return [...noResultsFound, ...createNewOne];
    }
    if (!searchValue && isTextSelected) {
      return createNewOne;
    }
    if (fullMatch) {
      return filteredSuggestions;
    } else {
      return isTextSelected ? [...filteredSuggestions, ...createNewOne] : filteredSuggestions;
    }
  }, [records, searchValue]);
  useEffect(() => {
    setSearchValue(searchValue);
    searchCallback(searchValue);
  }, []);
  const handleCleanClick = () => {
    setSearchValue('');
  };
  const handleSearchClick = () => {
    setSearchValue(searchValue);
  };
  const handleSuggestionClick = useCallback(({
    id,
    term,
    uuid,
    definition,
    business_line
  }, isPreview) => {
    if (id === -1 || !isTextSelected) return;
    if (id === 0) {
      // new one
      suggestionClickCallback({
        id,
        term: searchValue,
        uuid,
        definition: '',
        business_line
      }, isPreview);
    } else {
      // click on the existing one
      suggestionClickCallback({
        id,
        term,
        uuid,
        definition,
        business_line
      }, isPreview);
    }
  }, [searchValue]);
  const actionButtonClick = (suggestion, isPreview) => {
    handleSuggestionClick(suggestion, isPreview);
  };
  return /*#__PURE__*/React.createElement(SearchBarWrapper, null, /*#__PURE__*/React.createElement(FieldInput, {
    disabled: !isTextSelected,
    type: "text",
    value: searchValue,
    onChange: e => searchCallback(e.target.value),
    placeholder: GlossaryConst.SEARCH_BY_TERM,
    size: "M",
    startAction: /*#__PURE__*/React.createElement(SearchIconWrapper, {
      onClick: handleSearchClick
    }, /*#__PURE__*/React.createElement(Search, {
      "aria-hidden": true
    })),
    endAction: /*#__PURE__*/React.createElement(FieldAction, {
      onClick: handleCleanClick
    }, /*#__PURE__*/React.createElement(CloseIconWrapper, {
      hidden: !searchValue
    }, /*#__PURE__*/React.createElement(Cross, null)))
  }), options.length > 0 && /*#__PURE__*/React.createElement(Dropdown, null, options.map(suggestion => /*#__PURE__*/React.createElement(DropdownItem, {
    key: suggestion.term
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => handleSuggestionClick(suggestion, false),
    className: suggestion.id === -1 ? styles.textCursive : styles.w100
  }, suggestion.term), suggestion.id > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => actionButtonClick(suggestion, true)
  }, GlossaryConst.PREVIEW), /*#__PURE__*/React.createElement(Button, {
    onClick: () => actionButtonClick(suggestion, false),
    disabled: !isTextSelected
  }, GlossaryConst.SET)) : /*#__PURE__*/React.createElement(React.Fragment, null)))));
});
export default SearchInput;